import axios from 'axios';
// import { env } from 'config/env.js';
// import getRequest from 'utils/getRequest.js';
import { requestInter, responseInter } from './requestInter';
let type = process.env.VUE_APP_ENV;
// let baseUrl = env[type]['ajaxPath'];
let token = localStorage.getItem('token') || '';
let fetch = axios.create({
    // timeout: 10000,
    baseURL:  '/chuan-cheng',
    // baseURL: 'http://10.2.118.33:8010',
    headers: {
        'Authorization':'bearer' +token,
        // 'Content-Type': 'application/json'
        // 'X-Requested-With': 'XMLHttpRequest',
        // "Content-Type": "multipart/form-data",
    },
    withCredentials:true,
    // transformRequest: [
    //     function (data) {
    //         console.log(JSON.stringify(data))
    //         // const param = encodeURIComponent('body') + '=' + new Object(JSON.stringify(data))
    //         const param =  new Object(JSON.stringify(data))
    //         return JSON.stringify(data)
    //     }
    // ],
    // transformRequest: [function (data) {
    //     data = qs.stringify(data);
    //     return data;
    // }],

});
requestInter(fetch);
responseInter(fetch);
export default fetch;